import { useNavigate } from 'react-router-dom'
import {
  COLUMNS,
  ROW_HEIGHT,
  formatCompactCap,
  formatFundingDisplay,
  formatMarginPct,
  formatUsdPrice,
} from '../../data/fundingMarketRisk'
import { SignalIcon, StarIcon } from './icons'

const ROW_CLASS =
  'absolute flex w-full items-center max-mobile:px-1 gap-3 px-3 text-base/md text-ink tabular-nums group cursor-pointer hover:bg-ink/5 hover:[--row-tint:color-mix(in_oklab,var(--color-ink)_5%,transparent)] h-[44px] min-h-[44px]'

export default function RiskRow({ market, index, favorite, onToggleFavorite }) {
  const navigate = useNavigate()
  const testId = `row-${index}`
  const id = market.id
  const striped = index % 2 === 0 ? ' bg-ink/4' : ''

  return (
    <tr
      data-index={index}
      data-testid={testId}
      className={`${ROW_CLASS}${striped}`}
      style={{ transform: `translateY(${index * ROW_HEIGHT}px)` }}
      onClick={() => navigate(`/trade/${market.symbol}`)}
    >
      <td
        data-testid={`${testId}-cell-${id}_symbol`}
        className="flex grow items-center self-stretch"
        style={{ width: COLUMNS[0].width }}
      >
        <div
          className="flex w-full min-w-0 items-center gap-2 overflow-hidden"
          data-testid="market-selector-table-cell"
        >
          <button
            type="button"
            className={`inline-flex items-center gap-2 text-sm/sm font-medium disabled:opacity-50 disabled:no-underline shrink-0 rounded-pill p-1 no-underline hover:bg-ink/10 ${
              favorite
                ? 'text-ink hover:text-ink'
                : 'text-muted hover:text-meta active:text-meta'
            }`}
            aria-label={favorite ? 'Remove from favorites' : 'Add to favorites'}
            onClick={(event) => {
              event.stopPropagation()
              onToggleFavorite(market.symbol)
            }}
          >
            <span
              data-icon="true"
              className="flex shrink-0 items-center justify-center size-4"
            >
              <StarIcon />
            </span>
          </button>
          <div className="flex min-w-0 items-center gap-2">
            <div className="flex size-5 shrink-0 items-center justify-center">
              {market.logoUrl ? (
                <img
                  className="size-5 shrink-0"
                  src={market.logoUrl}
                  alt=""
                  onError={(event) => {
                    event.currentTarget.style.visibility = 'hidden'
                  }}
                />
              ) : null}
            </div>
            <span
              className="text-sm/sm text-ink shrink-0"
              data-testid={`market-selector-table-cell-${market.symbol}`}
            >
              {market.symbol}
            </span>
            {market.leverage ? (
              <span
                className="shrink-0 text-sm/sm text-ink/50 tabular-nums"
                data-testid="market-selector-table-cell-margin-fraction"
              >
                {market.leverage}x
              </span>
            ) : null}
            <div
              type="button"
              aria-haspopup="dialog"
              aria-expanded="false"
              data-state="closed"
            >
              <span
                data-icon="true"
                className="flex shrink-0 items-center justify-center size-4 cursor-pointer text-ink"
              >
                <SignalIcon clipId={`signal-${market.symbol}`} />
              </span>
            </div>
          </div>
        </div>
      </td>
      <td
        data-testid={`${testId}-cell-${id}_markPrice`}
        className="flex grow"
        style={{ width: COLUMNS[1].width }}
      >
        {formatUsdPrice(market.markPrice, market.priceDecimals)}
      </td>
      <td
        data-testid={`${testId}-cell-${id}_indexPrice`}
        className="flex grow"
        style={{ width: COLUMNS[2].width }}
      >
        <span className="text-dim">
          {formatUsdPrice(market.indexPrice, market.priceDecimals)}
        </span>
      </td>
      <td
        data-testid={`${testId}-cell-${id}_openInterestCap`}
        className="flex grow"
        style={{ width: COLUMNS[3].width }}
      >
        <span className="text-dim">{formatCompactCap(market.openInterestCap)}</span>
      </td>
      <td
        data-testid={`${testId}-cell-${id}_maintenanceMargin`}
        className="flex grow"
        style={{ width: COLUMNS[4].width }}
      >
        {formatMarginPct(market.maintenanceMargin)}
      </td>
      <td
        data-testid={`${testId}-cell-${id}_minFunding`}
        className="flex grow"
        style={{ width: COLUMNS[5].width }}
      >
        <span className="text-down">{formatFundingDisplay(market.minFunding)}</span>
      </td>
      <td
        data-testid={`${testId}-cell-${id}_maxFunding`}
        className="flex grow"
        style={{ width: COLUMNS[6].width }}
      >
        <span className="text-up">{formatFundingDisplay(market.maxFunding)}</span>
      </td>
    </tr>
  )
}
